import * as maplibregl from 'maplibre-gl';
import { get } from 'svelte/store';
import type { MapInfo } from '../../api/types';
import { mapCredits } from '../../stores/mapCredits';

// CreditPlace is where a map sits: the main map shows its credit in full,
// the share page always does, and the others show an (i) (spec 009).
export type CreditPlace = 'main' | 'other' | 'share';

// addCredits gives a map its credit, or none when the member turned credits
// off and the server's credit is OpenStreetMap's alone (009 FR-034, 009 FR-035, 009 FR-036, 009 FR-037, 009 FR-038, 009 FR-039).
export function addCredits(map: maplibregl.Map, info: MapInfo | null, place: CreditPlace) {
  const optional = info?.attribution_optional ?? false;
  if (place !== 'share' && optional && !get(mapCredits)) return;
  const customAttribution = info?.available ? undefined : info?.attribution;
  if (place !== 'other') {
    map.addControl(new maplibregl.AttributionControl({ compact: false, customAttribution }));
    return;
  }
  map.addControl(new maplibregl.AttributionControl({ compact: true, customAttribution }));
  // The compact control opens itself on load; an (i) is all a secondary
  // map shows until it is clicked.
  const collapse = () => map.getContainer().querySelector('.maplibregl-ctrl-attrib')?.classList.remove('maplibregl-compact-show');
  collapse();
  map.once('load', collapse);
}
